export const UI_CONFIG_ROUTES = {
  MAIN: "/ui-config-global",
  TABLE_ORDERING_MENU_LAYOUT: "/ui-config-global/table-ordering-menu-layout",
};
